
import ArrowLeftCircleIcon from "./Icons/ArrowLeftCircleIcon.vue";
import DispatchEventUtils from "./Mixins/DispatchEventUtils.js";

export default {
    name: "IndexItem",
    mixins: [DispatchEventUtils],
    components: {
        ArrowLeftCircleIcon
    },
    props: {
        source: Object,
        selectedDictionary: Object,
        isFirst: Boolean,
        isLast: Boolean,

    },
    computed:{
      isSelected() {
          return this.selectedDictionary && this.source.id === this.selectedDictionary.id
      }
    },
    methods: {
        setPage() {
            this.dispatch('FileViewer', 'set-page', this.source.id)
        }
    }
}
